module.exports = __webpack_public_path__ + "img/publicnumbercode.21eb72f6.jpg";